import VueForm from './vue/form.vue';
import Promise from 'promise-polyfill';
import './../../scss/main.scss';
import VueScrollTo from 'vue-scrollto';
import { validateSpanishId } from 'spain-id';

if (!window._babelPolyfill) {
    require("babel-polyfill");
}

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

Array.prototype.unique = function (field) {
    if(field){
        let mapped = this.map(i => i[field]);
        return this.filter((value, index) => mapped.indexOf(value[field]) === index);
    }
    else{
        return this.filter((value, index, self) => self.indexOf(value) === index);
    }
};

//DNI
window.validate.validators.dni = function (value, options) {
    if (!value) {
        return null;
    }

    if(validateSpanishId(value)){
        return null;
    }
    else{
        return options.invalid || options.message || 'Dni erroneo, formato no válido';
    }
}


let $ = window.jQuery;
Vue.use(VueScrollTo);

let init = async function(){
    let discounts = await getDiscounts();
    let courses = await getCourses(parameters.id);
    let partialDeposit = await getPartialDeposit();
    let paymentMethods = await getPaymentMethods();
    let permissionClient = await checkPermissionClient();

    let casalId = parameters.id;
    let defaultPartialDeposit = parameters.defaultPartialDeposit;
    let allowPartialDeposit = parameters.allowPartialDeposit;
    
    document.getElementById('preLoading').innerHTML = "";

    let form = new Vue({
        el: "#app",
        components: {
            VueForm,
        },
        data: {
            discounts,
            courses,
            partialDeposit,
            paymentMethods,
            permissionClient,
            casalId,
            isDefaultPartialDeposit: defaultPartialDeposit,
            allowPartialDeposit
        },
        template: `<VueForm 
                        ref='form' 
                        :discounts='discounts' 
                        :course='courses' 
                        :partialDeposit='partialDeposit' 
                        :allowPartialDeposit='allowPartialDeposit' 
                        :isDefaultPartialDeposit='isDefaultPartialDeposit' 
                        :paymentMethods='paymentMethods' 
                        :permissionClient='permissionClient' 
                        :casalId='casalId'></VueForm>`
    });
};
let getPaymentMethods = function(){
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: 'safa_get_payment_methods',
            },
            success: function (response) {
                resolve(response);
            },
            error: function (error) {
                reject(error);
            }
        });
    });
}
let getDiscounts = function () {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: 'safa_get_discounts',
            },
            success: function (response) {
                resolve(response);
            },
            error: function (error) {
                reject(error);
            }
        });
    });
};
let getCourses= function (casalId) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: 'safa_get_courses',
                casalId: casalId,
            },
            success: function (response) {
                let array = [
                    { text: 'SELECCIONA', value: null }
                ];

                if(response){
                    response = response.sort((a, b) => a.term_order - b.term_order);

                    for(let i = 0; i < response.length; i++){
                        array.push({ text: response[i].name, value: response[i].term_id });
                    }
                }

                resolve(array);
            },
            error: function (error) {
                reject(error);
            }
        });
    });
};
let getPartialDeposit = function () {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: 'safa_get_partial_deposit',
            },
            success: function (response) {
                resolve(parseInt(response));
            },
            error: function (error) {
                reject(error);
            }
        });
    });
};
let checkPermissionClient = function () {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: 'safa_check_permission_client',
            },
            success: function (response) {
                resolve(parseInt(response));
            },
            error: function (error) {
                reject(error);
            }
        });
    });
};

init();